import { render, staticRenderFns } from "./ResultTableMainProgram.vue?vue&type=template&id=1ded1d13&scoped=true&"
import script from "./ResultTableMainProgram.vue?vue&type=script&lang=js&"
export * from "./ResultTableMainProgram.vue?vue&type=script&lang=js&"
import style0 from "./ResultTableMainProgram.vue?vue&type=style&index=0&id=1ded1d13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ded1d13",
  null
  
)

export default component.exports